import { RoleResources } from '..'

import leads from './leads'
import stock from './stock'

export const forwarder: RoleResources = {
  forwarder_leads: leads,
  forwarder_stock: stock,
}
